import { api } from '../instance';
export const trackPostMetric = (trackPostMetricDto) => {
    return api.post('/analytics/track-post-metric', trackPostMetricDto);
};
export const trackPostMetricsBatch = (trackPostMetricDtos) => {
    return api.post('/analytics/track-post-metrics-batch', trackPostMetricDtos);
};
//# sourceMappingURL=track-post-metric.api.js.map